export const transNum = (num: number | null, trim?: any, price?: any) => {
  if (num === null) {
    return '-';
  }
  if (typeof num !== 'number') {
    return 0;
  }

  if (num >= 100000000) {
    return `${(Math.round(num / 10000000) / 10).toLocaleString()}${
      trim ? '' : ' '
    }억`;
  } else if (num >= 10000) {
    return price
      ? `${(Math.round(num / 1000) / 10).toLocaleString()}${trim ? '' : ' '}만`
      : `${Math.round(num / 10000).toLocaleString()}${trim ? '' : ' '}만`;
  } else if (num <= -100000000) {
    return `${(
      -1 *
      (Math.round((num * -1) / 10000000) / 10)
    ).toLocaleString()}${trim ? '' : ' '}억`;
  } else if (num <= -10000) {
    return price
      ? `${(Math.round(num / 1000) / 10).toLocaleString()}${trim ? '' : ' '}만`
      : `${Math.round(num / 10000).toLocaleString()}${trim ? '' : ' '}만`;
  } else {
    return price
      ? `${(num / 10000).toFixed(1).toLocaleString()}${trim ? '' : ' '}만`
      : `${Math.round(num).toLocaleString()}${trim ? '' : ' '}`;
  }
};
export const addSeparators = (number?: number): string => {
  if (typeof number !== 'number' || isNaN(number)) {
    return ''; // Handle invalid input gracefully
  }

  // 정수 부분만 추출
  const integerPart = Math.floor(number).toString();

  // 천 단위 구분 기호 추가
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatPercentage = (value?: number): string => {
  if (typeof value !== 'number' || isNaN(value)) {
    return ''; // Handle invalid input gracefully
  }

  // Format the value to one decimal place and add '%' sign
  return `${value.toFixed(1)}%`;
};

// 만원 단위 숫자를 한글로 변환하는 함수(억 + 만 단위)
export const formatToKoreanCurrency = (value: any) => {
  if (typeof value !== 'number') {
    value = Number(value);
  }
  const eok = Math.floor(value / 100000000); // 억 단위
  const man = Math.round((value % 100000000) / 10000); // 만 단위 (반올림)

  let result = '';

  if (eok > 0) {
    result += `${eok.toLocaleString()}억 `;
  }

  if (man > 0) {
    result += `${man.toLocaleString()}만원`;
  }

  return result.trim();
};

// 기존 음수 출력 transNum 함수
export const transNum2 = (num: number | null, trim?: any, price?: any) => {
  if (num === null) {
    return '-';
  }
  if (typeof num !== 'number') {
    return 0;
  }

  if (num >= 100000000) {
    return `${(Math.round(num / 10000000) / 10).toLocaleString()}${
      trim ? '' : ' '
    }억`;
  } else if (num >= 10000) {
    return price
      ? `${(Math.round(num / 1000) / 10).toLocaleString()}${trim ? '' : ' '}만`
      : `${Math.round(num / 10000).toLocaleString()}${trim ? '' : ' '}만`;
  } else if (num <= -100000000) {
    return `${(
      -1 *
      (Math.round((num * -1) / 10000000) / 10)
    ).toLocaleString()}${trim ? '' : ' '}억`;
  } else if (num <= -10000) {
    return price
      ? `${(Math.round(num / 1000) / 10).toLocaleString()}${trim ? '' : ' '}만`
      : `${Math.round(num / 10000).toLocaleString()}${trim ? '' : ' '}만`;
  } else {
    return price
      ? `${(num / 10000).toFixed(1).toLocaleString()}${trim ? '' : ' '}만`
      : `${Math.round(num).toLocaleString()}${trim ? '' : ' '}`;
  }
};

//숫자를 3자리마다 콤마 찍어주고 주어진 소수점 자리수만큼 반올림
export const numberWithCommas = (x: any, decimal: any) => {
  if (x === null) {
    return '';
  }
  return x.toFixed(decimal).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const numberWithCommas2 = (
  x: number | string,
  decimalPlaces: number,
) => {
  const num = typeof x === 'string' ? parseFloat(x) : x;

  if (isNaN(num)) return x;

  const factor = Math.pow(10, decimalPlaces);
  const truncated = Math.floor(num * factor) / factor;

  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
};

//추천안 문구 수정
export const recommendationText = (str: string) => {
  if (typeof str !== 'string' || str === '') return '';

  if (str.includes('신축')) {
    return '신축';
  } else if (str.includes('리모델링')) {
    return '리모델링';
  } else if (str.includes('리노베이션')) {
    return '리노베이션';
  } else if (str.includes('유지')) {
    return '기존 건물 유지';
  }
};

//20240101 string 을 2024.01.01로 변환
export const formatDate = (date: string | undefined) => {
  if (!date) {
    return '';
  }
  return date.replace(/(\d{4})(\d{2})(\d{2})/, '$1.$2.$3');
};
export const formatDate2 = (date: string | undefined) => {
  if (!date) {
    return '';
  }
  return date.replace(/(\d{4})(\d{2})(\d{2})/, '$1년$2월');
};

export const formatNumber = (number: number | string) => {
  // 문자열인 경우 숫자로 변환
  const numericValue = typeof number === 'string' ? parseFloat(number) : number;

  // 숫자가 유효하면 형식화하여 반환
  if (!isNaN(numericValue)) {
    return numericValue.toLocaleString();
  } else {
    return ''; // 숫자로 변환할 수 없는 경우 빈 문자열 반환
  }
};

/**
 * "2024-09-12T10:02:34.217144" --> "2024.09.12"
 */
export const formatDate3 = (dateString: string): string => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('ko-KR').replace(/\./g, '.');

  return formattedDate.endsWith('.')
    ? formattedDate.slice(0, -1)
    : formattedDate;
};
